import type { Signal, WritableSignal } from '@angular/core';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';

import type { AppIdentity, UserConfig } from '@evc/platform';
import { PlatformComponent, PlatformService } from '@evc/platform';
import type { Maybe, Menu, MenuItemType } from '@evc/web-components';
import { SharedConfigService } from '@shared/services/config/config.service';
import { I18nService } from '@shared/services/i18n/i18n.service';

import { NavConfigService } from './services/nav-config/nav-config.service';

@Component({
  imports: [RouterModule, PlatformComponent],
  selector: 'evc-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  leftbarConfig: WritableSignal<Menu[]>;
  helpMenu: WritableSignal<MenuItemType[]>;
  appIdentification: Signal<AppIdentity>;
  i18nService = inject(I18nService);
  readonly #platformService = inject(PlatformService);

  #config = inject(SharedConfigService);
  #navConfig = inject(NavConfigService);

  #mockUser = signal<Maybe<UserConfig>>(undefined);
  get mockUser(): Signal<Maybe<UserConfig>> {
    return this.#mockUser.asReadonly();
  }
  ready: Signal<Maybe<true>> = this.#platformService.ready;

  constructor() {
    this.leftbarConfig = this.#navConfig.leftbarConfig;
    this.appIdentification = this.#navConfig.appIdentity;
    this.helpMenu = this.#navConfig.helpMenu;
  }
}
